<div class="resend-signed-consent-dialog">
  <mat-dialog-content>
    <div fxLayout="column" fxLayoutGap="16px">
      <div class="mat-h3">
        <span class="mdi mdi-alert-circle-outline color-warn"></span>
        {{ title }}
      </div>
      <div class="mat-body">{{ warning }}</div>
      <mat-form-field>
        <mat-label>Reason</mat-label>
        <textarea matInput [formControl]="reasonControl" maxlength="500" rows="3" required></textarea>
        <mat-hint>Required. Recorded on the application audit log.</mat-hint>
      </mat-form-field>
      <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-between center">
        <button mat-stroked-button color="primary" type="button" (click)="onCancel()">Cancel</button>
        <button mat-flat-button color="primary" type="button" [disabled]="reasonControl.invalid" (click)="onSubmit()">{{ submitLabel }}</button>
      </div>
    </div>
  </mat-dialog-content>
</div>
